import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ShIconModule } from '@stylehaven/components';

import { ActiveFilterPill } from './entities/active-filter-pill.entity';

/**
 * Presentational bar of removable active-filter pills shown above the record overview table. Dumb by
 * design: the container builds the pill list and handles removal — this component only renders the pills
 * (filled/primary vs outlined/secondary) and emits which one to remove or a request to clear all.
 */
@Component({
    standalone: true,
    selector: 'digihaven-active-filter-bar',
    templateUrl: './active-filter-bar.component.html',
    styleUrls: ['./active-filter-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ShIconModule]
})
export class ActiveFilterBarComponent {
    @Input() pills: ActiveFilterPill[] = [];

    @Input() savedQueryActive = false;

    @Output() removePill: EventEmitter<ActiveFilterPill> = new EventEmitter();
    @Output() clearAll: EventEmitter<void> = new EventEmitter();

    onRemove(pill: ActiveFilterPill): void {
        this.removePill.emit(pill);
    }

    onClearAll(): void {
        this.clearAll.emit();
    }
}
